module.exports = __webpack_public_path__ + "static/media/icon.7b6a0582.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/icon.svg
// module id = 465
// module chunks = 0